var exports = {
  "r": "submittedFeedbackButton__B4CMtS",
};

module.exports = exports;
